// @ts-nocheck
import {useMutation, useQueryClient} from "@tanstack/react-query";
import {toggleProviderFollowService} from "../../services/games/gameFeed/providerGames.service";

const useToggleProviderFollow = provider => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => toggleProviderFollowService(provider),
    onSuccess: () => {
      // Refetch the provider games query to get the updated follow state and count.
      queryClient.invalidateQueries({queryKey: ["providerGames", provider]});
    },
    onError: () => {
      queryClient.invalidateQueries({queryKey: ["providerGames", provider]});
    },
  });
};

export default useToggleProviderFollow;
